<template>
	<div class="gallery">
		<v-touch class="gallery-touch-swipe" @swiperight="previousImage" @swipeleft="nextImage">
			<modal v-if="mq.current >= mq.md" class="modal-wrap">
				<ximg
					slot="label"
					:src="images[showingImageIndex].large"
					:previewUrl="images[showingImageIndex].thumb"
					:ariaLabel="imageName + ' large image ' + showingImageIndex"
					role="img"
				/>
				<image-slideshow
					class="gallery-slideshow"
					:images="images"
					:initialImageIndex="selectedImageIndex"
					:imageName="imageName"
				/>
			</modal>
			<div v-else class="ap-fill p-5" style="background-color: white;">
				<ximg
					:src="images[showingImageIndex].large"
					:previewUrl="images[showingImageIndex].thumb"
					:ariaLabel="imageName + ' image ' + showingImageIndex"
					role="img"
				/>
			</div>
		</v-touch>
		<div v-if="mq.current <= mq.sm && images.length > 1" class="mt-5" style="text-align: center;">
			<span
				v-for="index in images.length"
				:key="'gallery-dot-' + index"
				:class="['gallery-dot', { active: index - 1 === selectedImageIndex }]"
				@click="selectImage(index - 1)"
			/>
		</div>
		<div v-else-if="images.length > 1" class="gallery-thumbnail-wrap">
			<icon-button v-if="images.length > 3" variant="left" @click="previousImage" />
			<div ref="thumbnail-gallery" @mouseout="stopPeek" class="relative mx-2 gallery-thumbnails">
				<span
					v-for="(img, index) in images"
					:key="'gallery-thumbnail-' + index"
					:class="['gallery-thumbnail', { selected: selectedImageIndex == index}]"
					ref="thumbnail-image"
					@mouseover="peekImage(index)"
					@click="selectImage(index)"
				>
					<ximg
						:src="img.thumb"
						:ariaLabel="imageName + ' thumbnail ' + index"
						role="img"
					/>
				</span>
			</div>
			<icon-button v-if="images.length > 3" variant="right" @click="nextImage" />
		</div>
	</div>
</template>

<script>
import Tween from 'tween';
import mq from 'mediaQuery';

export default {
	data () {
		return {
			mq,
			showingImageIndex: 0,
			selectedImageIndex: 0,
		};
	},
	props: {
		images: {
			type: Array,
			required: true,
		},
		imageName: {
			type: String,
			required: true,
		},
	},
	methods: {
		peekImage (index) {
			this.showingImageIndex = index;
		},
		stopPeek (event) {
			const el = this.$refs['thumbnail-gallery'];
			if (el && el.contains(event.toElement)) {
				return;
			}
			this.showingImageIndex = this.selectedImageIndex;
		},
		selectImage (index) {
			this.selectedImageIndex = index;
			this.showingImageIndex = index;
		},
		nextImage () {
			if (this.selectedImageIndex < this.images.length - 1) {
				this.selectedImageIndex++;
			} else {
				this.selectedImageIndex = 0;
			}
			this.showingImageIndex = this.selectedImageIndex;
		},
		previousImage () {
			if (this.selectedImageIndex > 0) {
				this.selectedImageIndex--;
			} else {
				this.selectedImageIndex = this.images.length - 1;
			}
			this.showingImageIndex = this.selectedImageIndex;
		},
	},
	watch: {
		selectedImageIndex (index) {
			const el = this.$refs['thumbnail-gallery'];
			if (el) {
				const targetEl = this.$refs['thumbnail-image'][index];

				if (el.scrollLeft > targetEl.offsetLeft) {
					new Tween(el, { scrollLeft: targetEl.offsetLeft - 2 }, .2);
				}

				if (el.scrollLeft + el.offsetWidth < targetEl.offsetLeft + targetEl.offsetWidth - 2) {
					new Tween(el, { scrollLeft: targetEl.offsetLeft - el.offsetWidth + targetEl.offsetWidth + 2 }, .2);
				}
			}
		},
		images (images) {
			this.showingImageIndex = 0;
			this.selectedImageIndex = 0;
		},
	},
};
</script>
